import { $, w } from './constants';

$(function () {
	const $form = $('.form_JS');
	if (!$form.length) return;

	$.validator.addMethod("fileValidation", function (value, element) {
		const file = element.files[0];

		// Let "required" handle empty case
		if (!file) return true;

		const isPDF = file.type === 'application/pdf';
		const maxSize = 10 * 1024 * 1024;

		return isPDF && file.size <= maxSize;

	}, $('.js-msg-file').text());

	initContactForm();

	const $fileInput = $('input[name="cv"]');
	const $fileName = $('.js-file-name');

	$fileInput.on('change', function () {
		const file = this.files[0];

		if (file) {
			$fileName.text(file.name).removeClass('hidden');
		} else {
			$fileName.text('').addClass('hidden');
		}
	});
});

function getValidationMessages() {
	return {
		name: {
			required: $('.js-msg-name').text()
		},
		tel: {
			required: $('.js-msg-tel').text()
		},
		email: {
			required: $('.js-msg-email-required').text(),
			email: $('.js-msg-email-invalid').text()
		},
		area: {
			required: $('.js-msg-area').text()
		},
		cv: {
			required: $('.js-msg-file-required').text(),
			fileValidation: $('.js-msg-file').text()
		}
	};
}

function initContactForm() {

	$('.form_JS').validate({

		ignore: [],

		onfocusout: function (element) { $(element).valid(); },

		rules: {
			name: { required: true },
			tel: { required: true },
			email: { required: true, email: true },
			area: { required: true },
			cv: { required: true, fileValidation: true }
		},

		messages: getValidationMessages(),

		errorClass: "error-label",
		errorElement: "span",

		// ❌ Disable default error placement
		errorPlacement: function () { return false; },

		// ✅ Custom error handling
		showErrors: function (errorMap, errorList) {

			// Hide all messages first
			$('.js-msg-name, .js-msg-tel, .js-msg-email-required, .js-msg-email-invalid, .js-msg-area, .js-msg-file-required, .js-msg-file')
				.addClass('hidden');

			// Show only relevant ones
			errorList.forEach(function (error) {
				const name = error.element.name;

				if (name === 'name') {
					$('.js-msg-name').removeClass('hidden');
				}

				if (name === 'tel') {
					$('.js-msg-tel').removeClass('hidden');
				}

				if (name === 'email') {
					if (error.method === 'required') {
						$('.js-msg-email-required').removeClass('hidden');
					} else {
						$('.js-msg-email-invalid').removeClass('hidden');
					}
				}

				if (name === 'area') {
					$('.js-msg-area').removeClass('hidden');
				}

				if (name === 'cv') {
					if (error.method === 'required') {
						$('.js-msg-file-required').removeClass('hidden');
					} else {
						$('.js-msg-file').removeClass('hidden');
					}
				}
			});
		},

		submitHandler: function (form, event) {
			event.preventDefault();

			const $btn = $(form).find('button[type="submit"]');
			$btn.prop('disabled', true).addClass('inactive');

			let formData = new FormData(form);

			$.ajax({
				url: cltvo_js_vars.ajax_url,
				type: 'POST',
				data: formData,
				contentType: false,
				processData: false,

				success: function (response) {
					if (response.success) {
						form.reset();

						$(form).fadeOut(300, function () {
							$('.form_success_JS').fadeIn(300);
						});
					} else {
						alert(response.data?.message || 'Error');
					}
				},

				error: function (err) {
					console.error("ERROR", err);
					alert(err.responseJSON?.message || "Hubo un error, por favor intenta de nuevo más tarde.");
				},

				complete: function () {
					$btn.prop('disabled', false).removeClass('inactive');
				}
			});
		}
	});
}